import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { login as handleLogin,signUp as handleSignUp, logout as handleLogout } from 'auth'
import localStorage from 'helpers/localStorage'

const getAuthToken = () => {
  return localStorage.getItem('authToken')
}

const getIsAuthenticated = () => {
  return localStorage.getItem('isAuthenticated') === true
}

const initialState = {
  loading: false,
  authToken: getAuthToken(),
  isAuthenticated: getIsAuthenticated(),
  isNewUser:false,
  error: false,
  errorMsg: ''
}

export const slice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    logout: (state) => {
      state['loading'] = false
      state['authToken'] = ''
      state['isAuthenticated'] = false
      state['error'] = false
      state['errorMsg'] = ''
    }
  },
  extraReducers: (builder) => {
    builder.addCase(loginUser.pending, (state, action) => {
      state['loading'] = true
      state['error'] = false
      state['errorMsg'] = ' '

    })
    builder.addCase(loginUser.fulfilled, (state, action) => {
      state['loading'] = false
      const {access}=action.payload
      const {token}=access
      if (token) {
        state['authToken'] = token
        state['isAuthenticated'] = true
      }

      state['loading'] = false
    })
    builder.addCase(loginUser.rejected, (state, action) => {
      state['loading'] = false
      state['error'] = true
      state['errorMsg'] = action.error?.message || 'Oops! Error occurred, please try again later'
    })

    // for sign up

    builder.addCase(signUpUser.pending, (state, action) => {
      state['loading'] = true
      state['error'] = false
      state['errorMsg'] = ''
    })
    builder.addCase(signUpUser.fulfilled, (state, action) => {
      state['loading'] = false
      const {access}=action.payload
      const {token}=access
      if (token) {
        state['authToken'] = token
        state['isAuthenticated'] = true
      }
      state['isNewUser']=true
      state['loading'] = false
    })
    builder.addCase(signUpUser.rejected, (state, action) => {
      state['loading'] = false
      state['error'] = true
      state['errorMsg'] =
        action.error?.message || 'Oops!Signup Error occurred, please try again later'
    })
  }
})

export const { login, signUp, logout } = slice.actions

// Login user
export const loginUser = createAsyncThunk('auth/loginUser', async (loginInfo) => {
  return await handleLogin(loginInfo)
})

//signup user
export const signUpUser = createAsyncThunk('auth/signUpUser', async (signUpInfo) => {
  return await handleSignUp(signUpInfo)
})

//Logout user
export const logoutUser = () => (dispatch) => {
  handleLogout()
  dispatch(logout())
}

// Selectors
export const selectAuth = (state) => state.auth
export const selectAuthToken = (state) => state.auth.authToken
export const selectIsSignedIn = (state) => !!state.auth.authToken && state.auth.isAuthenticated
export const selectIsNewUser=(state)=>state.auth.isNewUser

export default slice.reducer
